import FlashLib from 'flashlib_onlyplay';

export default class Symbol extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.id = 1;
    this.reel = 0;
    this.inactiveTintColor = 0x643131;
    this.init();
    this.changeSymbol(this.id);
  }

  init() {
    this.animationSymbol = this.getChildByName('animationContainer');
    this.firstFrameContainer = this.getChildByName('image');
    if (this.firstFrameContainer) {
      this.firstFrameContainer.addChild(new PIXI.Sprite());
      this.firstFrameContainer.sprite = this.firstFrameContainer.children[0];
      this.firstFrameContainer.position = this.animationSymbol.position;
    }
  }

  changeSymbol(id, reel, type) {
    this.id = id;
    this.reel = reel;
    this.type = type;
    this.goToFrame(this.id);
    this.background = this.getChildAt(0);
    this.image = this.getChildAt(2);
    if (this.firstFrameContainer && this.animationSymbol && this.type) {
      const firstFrameData = this.animationSymbol.getFirstFrameData(id, this.type);
      this.firstFrameContainer.sprite.texture = firstFrameData.texture;
      this.firstFrameContainer.sprite.pivot.set(firstFrameData.pivot.x, firstFrameData.pivot.y);
    }
    this.stopAnimation();
    this.stopFire();
    if (this.animationSymbol) this.animationSymbol.id = id;
    if (this.animationSymbol) this.animationSymbol.type = this.type;
  }

  startAnimation() {
    if(!this.animationSymbol.animation.autoUpdate) return;
    this.animationSymbol.start(false);
    this.image.visible = false;
  }

  stopAnimation() {
    this.image.visible = true;
    this.image.alpha = 1;

    if (this.animationSymbol) this.animationSymbol.stop();
  }

  stopFire() {
    if (this.animationSymbol) this.animationSymbol.stopFire();
  }

  startFire() {
    if (this.animationSymbol) this.animationSymbol.startFire();
  }

  setActive(value) {
    const sprite = this.firstFrameContainer?.sprite || this.image;
    sprite.tint = value ? 16777215 : this.inactiveTintColor;
    this.background.tint = value ? 16777215 : this.inactiveTintColor;
  }
}
